var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServer01 = function SvgServer01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "server-01_svg2__a",
    x1: 11.3,
    x2: 192.95,
    y1: 180.83,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#server-01_svg2__a",
    id: "server-01_svg2__b",
    x1: -54.55,
    x2: 127.1,
    y1: 107.7,
    y2: -55.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#server-01_svg2__a",
    id: "server-01_svg2__c",
    x1: -31.35,
    x2: 150.29,
    y1: 133.46,
    y2: -30.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#server-01_svg2__a",
    id: "server-01_svg2__d",
    x1: -8.16,
    x2: 173.49,
    y1: 159.22,
    y2: -4.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#server-01_svg2__a",
    id: "server-01_svg2__e",
    x1: -2.08,
    x2: 179.57,
    y1: 165.97,
    y2: 2.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#server-01_svg2__a",
    id: "server-01_svg2__f",
    x1: 4.55,
    x2: 186.19,
    y1: 173.33,
    y2: 9.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#server-01_svg2__a",
    id: "server-01_svg2__g",
    x1: 21.11,
    x2: 202.76,
    y1: 191.72,
    y2: 28.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#server-01_svg2__a",
    id: "server-01_svg2__h",
    x1: 27.74,
    x2: 209.39,
    y1: 199.08,
    y2: 35.51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#server-01_svg2__a",
    id: "server-01_svg2__i",
    x1: 44.31,
    x2: 225.96,
    y1: 217.48,
    y2: 53.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#server-01_svg2__a",
    id: "server-01_svg2__j",
    x1: 50.93,
    x2: 232.58,
    y1: 224.84,
    y2: 61.26
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M199.57 179.96c-1.84-7.13-9.11-11.41-16.23-9.57a13.33 13.33 0 0 0-9.57 9.57h-60.91c-1.22-4.66-4.86-8.3-9.52-9.52v-20.46h79.96c9.2-.01 16.65-7.46 16.66-16.66v-19.99a16.6 16.6 0 0 0-6.77-13.33 16.62 16.62 0 0 0 6.77-13.33V66.68a16.6 16.6 0 0 0-6.77-13.33 16.62 16.62 0 0 0 6.77-13.33V20.03c-.01-9.2-7.46-16.65-16.66-16.66H16.71C7.52 3.39.06 10.85.05 20.04v19.99c.01 5.26 2.53 10.21 6.77 13.33A16.6 16.6 0 0 0 .05 66.68v19.99C.06 91.93 2.58 96.88 6.82 100a16.61 16.61 0 0 0-6.77 13.32v19.99c.01 9.2 7.46 16.65 16.66 16.66h79.96v20.46c-4.66 1.22-8.3 4.86-9.52 9.52H26.23c-1.84-7.13-9.11-11.41-16.23-9.57-7.13 1.84-11.41 9.11-9.57 16.23 1.84 7.13 9.11 11.41 16.23 9.57 4.69-1.21 8.36-4.88 9.57-9.57h60.91c1.81 7.1 9.03 11.39 16.12 9.58 4.71-1.2 8.38-4.87 9.58-9.58h60.91c1.84 7.13 9.11 11.41 16.23 9.57s11.41-9.11 9.57-16.23Zm-186.19 9.99c-3.68 0-6.66-2.98-6.66-6.66s2.98-6.66 6.66-6.66 6.66 2.98 6.66 6.66-2.98 6.66-6.66 6.66M6.72 40.03V20.04c0-5.52 4.47-9.99 9.99-9.99h166.58c5.52 0 9.99 4.47 9.99 9.99v19.99c0 5.52-4.47 9.99-9.99 9.99H16.71c-5.52 0-9.99-4.47-9.99-9.99m0 46.64V66.68c0-5.52 4.47-9.99 9.99-9.99h166.58c5.52 0 9.99 4.47 9.99 9.99v19.99c0 5.52-4.47 9.99-9.99 9.99H16.71c-5.52 0-9.99-4.47-9.99-9.99m9.99 56.64c-5.52 0-9.99-4.47-9.99-9.99v-19.99c0-5.52 4.47-9.99 9.99-9.99h166.58c5.52 0 9.99 4.47 9.99 9.99v19.99c0 5.52-4.47 9.99-9.99 9.99zM100 189.95c-3.68 0-6.66-2.98-6.66-6.66s2.98-6.66 6.66-6.66 6.66 2.98 6.66 6.66-2.98 6.66-6.66 6.66m86.62 0c-3.68 0-6.66-2.98-6.66-6.66s2.98-6.66 6.66-6.66 6.66 2.98 6.66 6.66-2.98 6.66-6.66 6.66",
    style: {
      fill: "url(#server-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.37 40.03h16.66c1.84 0 3.33-1.49 3.33-3.33V23.37c0-1.84-1.49-3.33-3.33-3.33H23.37c-1.84 0-3.33 1.49-3.33 3.33V36.7c0 1.84 1.49 3.33 3.33 3.33m3.34-13.33h9.99v6.66h-9.99z",
    style: {
      fill: "url(#server-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.37 86.67h16.66c1.84 0 3.33-1.49 3.33-3.33V70.01c0-1.84-1.49-3.33-3.33-3.33H23.37c-1.84 0-3.33 1.49-3.33 3.33v13.33c0 1.84 1.49 3.33 3.33 3.33m3.34-13.32h9.99v6.66h-9.99z",
    style: {
      fill: "url(#server-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.03 113.32H23.37c-1.84 0-3.33 1.49-3.33 3.33v13.33c0 1.84 1.49 3.33 3.33 3.33h16.66c1.84 0 3.33-1.49 3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33m-3.33 13.33h-9.99v-6.66h9.99z",
    style: {
      fill: "url(#server-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31 23.37h33.32c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-33.32c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#server-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31 36.7h33.32c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-33.32c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#server-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31 70.01h33.32c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-33.32c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#server-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31 83.34h33.32c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-33.32c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#server-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.63 109.99h-33.32c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h33.32c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#server-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.63 123.32h-33.32c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h33.32c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#server-01_svg2__j)"
    }
  }));
};
export default SvgServer01;